/**
 * @ngdoc directive
 * @name drvTextAreaInput
 *
 * @description
 * A text area which automatically resizes to the binded data.
 *
 * # Scope Properties
 *
 * {Object} ngModel - The model value which will be used by the directive
 * {Object} field - Field configuration information for the directive. This matches the properties on the entity template field, as listed below.
 *      Name - This will be used for the label
 *      Description - If supplied, this will be shown when the help text is toggled
 *      Mandatory - Is a value required
 */

(function () {
    'use strict';

    drvTextAreaInput.$inject = [];
    drvTextAreaInputCtrl.$inject = [];

    angular
        .module('app')
        .directive('drvTextAreaInput', drvTextAreaInput);

    function drvTextAreaInput() {
        return {
            templateUrl: 'app/fieldinput/text-area-input.tmpl.html',
            require: "ngModel",
            scope: {
            },
            controller: drvTextAreaInputCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                value: '=ngModel',
                field: '=',
                ngBlur: '&'
            }
        };
    }

    function drvTextAreaInputCtrl() {
    }
})();
